import React from 'react';
import { Box } from '@mui/material';
import AboutHero from '../marketing-page/components/AboutHero';
import Mission from '../marketing-page/components/Mission';
import AboutFAQ from '../marketing-page/components/AboutFAQ';
import SiteFooter from '../components/SiteFooter';

export default function AboutPage() {
  return (
    <Box sx={{ width: '100%' }}>
      <AboutHero />
      <Mission />
      <Box>
        <AboutFAQ />
        <SiteFooter />
      </Box>
    </Box>
  );
}
